import { TextFieldModule } from '@angular/cdk/text-field';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { ExperimentCreateDetailsComponent } from '@components/experiment-create-details/experiment-create-details.component';

@NgModule({
    declarations: [ExperimentCreateDetailsComponent],
    exports: [ExperimentCreateDetailsComponent],
    imports: [FormsModule, MatCardModule, MatInputModule, TextFieldModule]
})
export class ExperimentCreateDetailsModule { }